import api from '@/api/partners';
import store from '@/store/store';

const fetchPartners = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchPartners(criteria.pageIndex, criteria.searchTerm, criteria.orderInfo)
    .then((response) => {
      resolve(response);
      store.commit('partners/storePartnerList', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchAllPartner = context => new Promise(((resolve, reject) => {
  api.fetchAllPartner()
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchPartner = (context, id) => new Promise(((resolve, reject) => {
  api.fetchPartner(id)
    .then((response) => {
      resolve(response);
      store.commit('partners/storePartner', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchPartnerChartData = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchPartnerChartData(criteria.id, criteria.siteId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchPartnerNotifications = (context, id) => new Promise(((resolve, reject) => {
  api.fetchPartnerNotifications(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updatePartner = (context, params) => new Promise(((resolve, reject) => {
  api.updatePartner(params)
    .then((response) => {
      resolve(response);
      store.commit('partners/storeUpdatedPartner', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const createPartner = (context, params) => new Promise(((resolve, reject) => {
  api.createPartner(params)
    .then((response) => {
      resolve(response);
      store.commit('partners/storeCreatedPartner', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deletePartner = (context, id) => new Promise(((resolve, reject) => {
  api.deletePartner(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchCommonData = (context, id) => new Promise(((resolve, reject) => {
  api.fetchCommonData(id)
    .then((response) => {
      context.commit('storeCommonData', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

export default {
  fetchPartners,
  fetchAllPartner,
  fetchPartner,
  fetchPartnerChartData,
  fetchPartnerNotifications,
  updatePartner,
  createPartner,
  deletePartner,
  fetchCommonData,
};




// WEBPACK FOOTER //
// ./src/store/modules/partners/actions.js